<template>
<div v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}第三方供应商`">
    </pt-page-title>
    <!-- <form-with-data v-model="currentForm"></form-with-data> -->
    <vendor-form v-model="currentForm" ref="form" @isUpload="isUpload"></vendor-form>
    <div class="button-div">
        <el-button type="primary" @click="save" :loading="saveLoading">保存</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
// import formWithData from './withData'
import vendorForm from './form'
export default {
  components: {
    vendorForm
  },
  computed: {
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      saveLoading: false,
      currentForm: {
        // 基本信息
        base: {
          qualifications: [],
          contracts: [],
          licenses: []
        },
        // 发票
        invoice: {
          type: 'SPECIAL_VAT'
        },
        // 售后政策
        policy: {},
        invoiceProvides: ['ELECTRONIC'],
        uploading: null
      }
    }
  },
  methods: {
    isUpload (val) {
      this.uploading = val
    },
    save () {
      this.$refs.form.validate().then(formValue => {
        // this.$store.dispatch('').then(data => {
        //   // doing something ...
        // }).catch(errorMessage => {
        //   console.error(errorMessage)
        //   this.$message.error(errorMessage)
        // })
        if (this.uploading) {
          this.$message.error('正在上传文件！请稍等...')
          return
        }
        this.loading = true
        this.changeForm()
        this.isEdit ? this.edit() : this.create()
      })
    },
    changeForm () {
      let copyData = JSON.parse(JSON.stringify(this.currentForm))
      copyData.invoiceProvides = copyData.invoiceProvides.map(e => {
        return {
          invoice: e,
          provide: true
        }
      })
      if (copyData.base.contracts && copyData.base.contracts.length) {
        copyData.base.contracts = copyData.base.contracts.map(e => {
          return {
            name: e.name,
            url: e.response || e.url
          }
        })
      }
      if (copyData.base.licenses && copyData.base.licenses.length) {
        copyData.base.licenses = copyData.base.licenses.map(e => {
          return {
            name: e.name,
            url: e.response || e.url
          }
        })
      }
      copyData.name = copyData.base.name
      copyData.type = 'EXTERNAL'
      copyData.roles = ['VENDOR']
      return copyData
    },
    create () {
      console.log('this.changeForm()-------', this.changeForm())
      this.$store.dispatch('createVendor', this.changeForm()).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit () {
      console.log('this.changeForm()-------', this.changeForm())
      this.$store.dispatch('updateVendor', this.changeForm()).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getVendor', this.$route.params.id).then(data => {
        this.loading = false
        if (data.invoiceProvides) {
          data.invoiceProvides = data.invoiceProvides.map(e => e.invoice)
        } else {
          data.invoiceProvides = []
        }
        if (!data.base) {
          data.base = {}
        }
        if (!data.invoice) {
          data.invoice = {}
        }
        this.currentForm = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
<style module lang="less">

</style>
